import PropTypes from 'prop-types';

import { ASC } from '@/common/constants';

export const LocalSortDefaultProps = {
  disabled: false,
  isLoading: false,
  options: [],
  setSortCode: () => {},
  setSortDirection: () => {},
  sortCode: null,
  sortDirection: ASC,
  sortables: {},
};

export const LocalSortPropTypes = {
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      key: PropTypes.string,
      label: PropTypes.string,
      label_mobile: PropTypes.string,
      sortable: PropTypes.bool,
    }),
  ),
  setSortCode: PropTypes.func,
  setSortDirection: PropTypes.func,
  sortables: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  sortCode: PropTypes.string,
  sortDirection: PropTypes.string,
};
